import { rawColors } from "./color";
import { CustomizableColors } from "./CustomizableColors";


export const joblifeColors:CustomizableColors = {

    primary:{
        light:"rgba(241,241,240, 1)",
        normal:"rgba(154,153,154, 1)",
        dark:"rgba(74,73,74, 1)"
    },

    secondary:"rgba(247,207,113, 1)",
    
    active: {
        default: { normal: rawColors.gray.dark, hover: rawColors.black },
        dark: { normal: rawColors.gray.dark, hover: rawColors.black }
    },

    mainNavigation:{
        background:"#3c0f11",
        backgroundSelected:"#f9423a",
        divider:"#f9423a",
        color:"white",
        colorSelected:"#3c0f11"
    },

    button: {
        filled: {
            background: "#3c0f11",
            backgroundHover: "#f9423a"
        },
        outlined: {
            border: "#3c0f11",
            text: "#3c0f11",
            textHover: "#f9423a"
        },
        text: {
            text: "#3c0f11",
            textHover: "#f9423a",
            backgroundHover: "rgba(241,241,240, 1)"
        },
        light: {
            text: "#3c0f11",
            textHover: "#f9423a",
            background: "rgba(241,241,240, 1)",
            backgroundHover: "rgba(241,241,240, 1)"
        }
    },
}